import {
  listingRoomLabel,
  listingUnitTypeLabel,
} from 'components/propertyCard/listingCardMeta'
import type { TFunction } from 'i18next'
import { Unit } from 'newTypes/unit'

/**
 * MVP title: structured from typology + rooms + place (avoids free-form noise).
 * Example: "Condo · 5 ½ · Sainte-Foy"
 */
export function buildStructuredListingTitle(t: TFunction, listing: Unit): string {
  const unit = listingUnitTypeLabel(t, listing)
  const rooms = listing.bedrooms
    ? listingRoomLabel(t, listing.bedrooms)
    : null
  const place =
    listing.address?.neighborhood?.trim() ||
    listing.address?.city?.trim() ||
    ''

  const parts = [unit, rooms, place].filter(
    (p): p is string => Boolean(p && p !== '—')
  )

  if (parts.length >= 2) return parts.join(' · ')
  if (parts.length === 1) return parts[0]
  const fallback = listing.title?.trim()
  return fallback || String(t('listing.detail.untitled'))
}
